export const LOCAL_BOX_URL = 'http://localhost:3002'